import { getMessaggeByCode } from "../../_const/common/message.api";


export class StatusCode {
    code: number;
    message: string;
    data: any;
}

export function statusCodeSuccess(): StatusCode {
    const s = new StatusCode();
    s.code = 200;
    return s;
}

export function statusCodeSuccessV2(model, data): StatusCode {
    model.code = 200;
    if (data) {
        model.data = data;
    }
    return model;
}

export class StatusCodeData<T> {
    code: number;
    message: string;
    data: T;
}

export function checkCodeApi(stautsCode: StatusCode, err): StatusCode {
    let errConst = err.error;
    stautsCode.code = err.status;
    if (err.error && err.error.message) {
        errConst = err.error.message;
    }
    else if (err.error && err.error.code) {
        errConst = err.error.code;
    }
    stautsCode.message = getMessaggeByCode(errConst);
    return stautsCode;
}

